import { APP_API_URL } from '../../../utils/xhr-instance';
import { getLocalStorageData } from '../../../utils/helper';
import axiosInstance from '../../../services/axios';

export const INVENTORY_ADJUSTMENT_CREATE_DONE = 'INVENTORY_ADJUSTMENT_CREATE_DONE';
export const INVENTORY_ADJUSTMENT_CREATE_FAIL = 'INVENTORY_ADJUSTMENT_CREATE_FAIL';

export const INVENTORY_ADJUSTMENT_LIST_GET_DONE = 'INVENTORY_ADJUSTMENT_LIST_GET_DONE';
export const INVENTORY_ADJUSTMENT_LIST_GET_FAIL = 'INVENTORY_ADJUSTMENT_LIST_GET_FAIL';

export const REFERANCE_NUMBER_GET_DONE = 'REFERANCE_NUMBER_DONE';
export const REFERANCE_NUMBER_GET_FAIL = 'REFERANCE_NUMBER_FAIL';

export const INVENTORY_ADJUSTMENT_UPDATE_DONE = 'INVENTORY_ADJUSTMENT_UPDATE_DONE';
export const INVENTORY_ADJUSTMENT_UPDATE_FAIL = 'INVENTORY_ADJUSTMENT_UPDATE_FAIL';

export const INVENTORY_ADJUSTMENT_DELETE_DONE = 'INVENTORY_ADJUSTMENT_DELETE_DONE';
export const INVENTORY_ADJUSTMENT_DELETE_FAIL = 'INVENTORY_ADJUSTMENT_DELETE_FAIL';

export const INVENTORY_ADJUSTMENT_CONVERT_DONE = 'INVENTORY_ADJUSTMENT_CONVERT_DONE';
export const INVENTORY_ADJUSTMENT_CONVERT_FAIL = 'INVENTORY_ADJUSTMENT_CONVERT_FAIL';

export const INVENTORY_ADJUSTMENT_CREATE_API_URL = `${APP_API_URL}/product/inventory-adjustment`;
export const INVENTORY_ADJUSTMENT_LIST_API_URL = `${APP_API_URL}/product/inventory-adjustment/list`;
export const INVENTORY_ADJUSTMENT_UPDATE_API_URL = `${APP_API_URL}/product/inventory-adjustmtent/update`;
export const INVENTORY_ADJUSTMENT_DELETE_API_URL = `${APP_API_URL}/product/inventory-adjustment/delete`;
export const INVENTORY_ADJUSTMENT_CONVERT_API_URL = `${APP_API_URL}/product/inventory-adjustment/convert-to-adjustment`;
export const INVENTORY_ADJUSTMENT_REVERT_API_URL = `${APP_API_URL}/product/inventory-adjustment/revert-to-adjustment`;
export const REFERANCE_NUMBER_API_URL = `${APP_API_URL}/product/get-reference-number`;
export const PRODUCT_LIST_GET_API_URL = `${APP_API_URL.replace('/v1', '/v2')}/inventory/product-lists`;

export const getProductLists = async (param = '') => {
	let API_URL = PRODUCT_LIST_GET_API_URL;
	if (param) API_URL = `${PRODUCT_LIST_GET_API_URL}?${param}`;
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

export const getProductListDetails = async (id) => {
	let API_URL = `${PRODUCT_LIST_GET_API_URL}/${id}`;
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

export const deleteProductList = async (idOrIds) => {
	let API_URL = `${PRODUCT_LIST_GET_API_URL}`;
	if (Array.isArray(idOrIds)) {
		API_URL = `${PRODUCT_LIST_GET_API_URL}?ids=${idOrIds.join(',')}`;
	} else if (idOrIds) {
		API_URL = `${PRODUCT_LIST_GET_API_URL}/${idOrIds}`;
	}
	const token = getLocalStorageData();
	return await axiosInstance
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
			data: Array.isArray(idOrIds) ? { product_list_ids: idOrIds } : undefined,
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

export const createProductList = async (formBody) => {
	let API_URL = `${PRODUCT_LIST_GET_API_URL}`;
	const token = getLocalStorageData();
	return await axiosInstance
		.post(API_URL, formBody, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

export const updateProductList = async (id, formBody) => {
	let API_URL = `${PRODUCT_LIST_GET_API_URL}/${id}`;
	const token = getLocalStorageData();
	const payload = {
		product_list_id: Number(id),
		...formBody,
	};
	return await axiosInstance
		.put(API_URL, payload, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

let token = getLocalStorageData();
const config = {
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token?.token}`,
	},
};

export const inventoryAdjustmentCreate = (formBody) => {
	let API_URL = INVENTORY_ADJUSTMENT_CREATE_API_URL;
	const token = getLocalStorageData();
	return (dispatch) => {
		return axiosInstance
			.post(API_URL, formBody, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			})
			.then((res) => {
				if (res?.data?.success) {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CREATE_DONE,
						payload: res.data,
					});
					return res.data;
				} else {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CREATE_FAIL,
						payload: res,
					});
					return res;
				}
			})
			.catch((err) => {
				dispatch({
					type: INVENTORY_ADJUSTMENT_CREATE_FAIL,
					payload: err,
				});
				return err;
			});
	};
};

export const inventoryAdjustmentList = async (param) => {
	let API_URL = `${INVENTORY_ADJUSTMENT_LIST_API_URL}?${param}`;
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};

export const inventoryAdjustmentUpdate = (id, formBody) => {
	let API_URL = `${INVENTORY_ADJUSTMENT_UPDATE_API_URL}/${id}`;
	const token = getLocalStorageData();
	return (dispatch) => {
		return axiosInstance
			.put(API_URL, formBody, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			})
			.then((res) => {
				if (res?.data?.success) {
					dispatch({
						type: INVENTORY_ADJUSTMENT_UPDATE_DONE,
						payload: res.data,
					});
					return res.data;
				} else {
					dispatch({
						type: INVENTORY_ADJUSTMENT_UPDATE_FAIL,
						payload: res,
					});
					return res;
				}
			})
			.catch((err) => {
				dispatch({
					type: INVENTORY_ADJUSTMENT_UPDATE_FAIL,
					payload: err,
				});
				return err;
			});
	};
};

export const inventoryAdjustmentDelete = (id) => {
	let API_URL = `${INVENTORY_ADJUSTMENT_DELETE_API_URL}/${id}?is_delete=1`;
	const token = getLocalStorageData();
	return (dispatch) => {
		return axiosInstance
			.delete(API_URL, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			})
			.then((res) => {
				if (res?.data?.success) {
					dispatch({
						type: INVENTORY_ADJUSTMENT_DELETE_DONE,
						payload: res.data,
					});
					return res.data;
				} else {
					dispatch({
						type: INVENTORY_ADJUSTMENT_DELETE_FAIL,
						payload: res,
					});
					return res;
				}
			})
			.catch((err) => {
				dispatch({
					type: INVENTORY_ADJUSTMENT_DELETE_FAIL,
					payload: err,
				});
				return err;
			});
	};
};

export const inventoryAdjustmentConvert = (id, body) => {
	let API_URL = `${INVENTORY_ADJUSTMENT_CONVERT_API_URL}/${id}`;
	const token = getLocalStorageData();
	return (dispatch) => {
		return axiosInstance
			.post(API_URL, body, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			})
			.then((res) => {
				if (res?.data?.success) {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CONVERT_DONE,
						payload: res.data,
					});
					return res.data;
				} else {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CONVERT_FAIL,
						payload: res,
					});
					return res;
				}
			})
			.catch((err) => {
				dispatch({
					type: INVENTORY_ADJUSTMENT_CONVERT_FAIL,
					payload: err,
				});
				return err;
			});
	};
};

export const inventoryAdjustmentReverted = (id) => {
	let API_URL = `${INVENTORY_ADJUSTMENT_REVERT_API_URL}/${id}`;
	const token = getLocalStorageData();
	return (dispatch) => {
		return axiosInstance
			.post(
				API_URL,
				{},
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token?.token}`,
					},
				},
			)
			.then((res) => {
				if (res?.data?.success) {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CONVERT_DONE,
						payload: res.data,
					});
					return res.data;
				} else {
					dispatch({
						type: INVENTORY_ADJUSTMENT_CONVERT_FAIL,
						payload: res,
					});
					return res;
				}
			})
			.catch((err) => {
				dispatch({
					type: INVENTORY_ADJUSTMENT_CONVERT_FAIL,
					payload: err,
				});
				return err;
			});
	};
};
export const getRefNumber = async (param) => {
	let API_URL = REFERANCE_NUMBER_API_URL;
	if (param) {
		API_URL = `${REFERANCE_NUMBER_API_URL}?${param}`;
	}
	const token = getLocalStorageData();
	return await axiosInstance
		.get(API_URL, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			if (res?.data?.success) {
				return res.data;
			} else {
				return res;
			}
		})
		.catch((err) => {
			return err;
		});
};
